<template>
  <page-table />
</template>
<script>
import PageTable from './components/table'
export default {
  name: 'system-thdapiOaLog',
  components: {
    PageTable,
  },
}
</script>
